import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { Weddings } from '../../Weddings';
import type { Agent } from '../Agents';
import type { IAction } from './Actions.types';

@Identifiable
@Timestampable
export class Action extends AbstractDocument<IAction> {
  readonly collections = {};

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}

export class Actions extends AbstractCollection<Action, IAction> {
  static path = 'actions';

  constructor(document: Agent) {
    super(document.collection(Actions.path), Action);
  }

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
